import { usePreorderItemStore } from '@/store/preorderItem';
import { version } from '../../package.json';

type Network = 'local' | 'sb' | 'rc' | 'stage' | 'live';
interface INetworkMap {
  staticAssetURL: string;
  staticUrl: string;
  loginUrl: string;
  logoutUrl: string;
  adminUrl: string;
}

interface ZoneMap {
  ncs:INetworkMap,
  nct:INetworkMap,
}

type Zone = 'ncs' | 'nct';
// 망 구분 regex 및 망 이름
const networkPattern: { name: Network; pattern: RegExp | null }[] = [
  { name: 'local', pattern: /^test/ },
  { name: 'sb', pattern: /^sb|test/ },
  { name: 'rc', pattern: /^rc/ },
  { name: 'stage', pattern: /^stage/ },
  { name: 'live', pattern: null },
];

// 망별 정보 Hashmap
const networkMap: { [key in Network]: ZoneMap } = {
  local: {
    ncs:{
      staticAssetURL: 'https://sb-assets.plaync.com',
      staticUrl: 'test.ncsoft.net:8080',
      loginUrl: 'https://sb-login.plaync.com/login/signin',
      logoutUrl: 'https://sb-login.plaync.com/login/signout',
      adminUrl: 'https://sb-preorder-admin.ncsoft.net',
    },
    nct:{
      staticAssetURL: 'https://sb-assets.plaync.com',
      staticUrl: 'test.ncsoft.net:8080',
      loginUrl: 'https://login.sb.plaync.com/nclogin/signin?prelogin_country_code=TW',
      logoutUrl: 'https://loginapi.sb.plaync.com/login/logout',
      adminUrl: 'https://sb-preorder-admin.ncsoft.net',
    }    
  },
  sb: {
    ncs:{
      staticAssetURL: 'https://sb-assets.plaync.com',
      staticUrl: 'sb-assets.plaync.com/uikit/preorder/client',
      loginUrl: 'https://sb-login.plaync.com/login/signin',
      logoutUrl: 'https://sb-login.plaync.com/login/signout',
      adminUrl: 'https://sb-preorder-admin.ncsoft.net',
    },
    nct:{
      staticAssetURL: 'https://sb-assets.plaync.com',
      staticUrl: 'sb-assets.plaync.com/uikit/preorder/client',
      loginUrl: 'https://login.sb.plaync.com/nclogin/signin?prelogin_country_code=TW',
      logoutUrl: 'https://loginapi.sb.plaync.com/login/logout',
      adminUrl: 'https://sb-preorder-admin.ncsoft.net',
    }    
  },
  rc: {
    ncs:{
      staticAssetURL: 'https://rc-assets.playnccdn.com',
      staticUrl: 'rc-assets.playnccdn.com/uikit/preorder/client',
      loginUrl: 'https://rc-login.plaync.com/nclogin/signin',
      logoutUrl: 'https://rc-loginapi.plaync.com/login/signout',
      adminUrl: 'https://rc-preorder-admin.ncsoft.net',
    },
    nct:{
      staticAssetURL: 'https://rc-assets.playnccdn.com',
      staticUrl: 'rc-assets.playnccdn.com/uikit/preorder/client',
      loginUrl: 'https://rc-login.plaync.com/nclogin/signin?prelogin_country_code=TW',
      logoutUrl: 'https://rc-loginapi.plaync.com/login/logout',
      adminUrl: 'https://rc-preorder-admin.ncsoft.net',
    }        
  },
  stage: {
    ncs:{
      staticAssetURL: 'https://stage-assets.plaync.com',
      staticUrl: 'https://stage-assets.plaync.com/uikit/preorder/client',
      loginUrl: 'https://login.plaync.com/nclogin/signin',
      logoutUrl: 'https://loginapi.plaync.com/login/logout',
      adminUrl: 'https://stage-preorder-admin.ncsoft.net',
    },
    nct:{
      staticAssetURL: 'https://stage-assets.plaync.com',
      staticUrl: 'https://stage-assets.plaync.com/uikit/preorder/client',
      loginUrl: 'https://login.plaync.com/nclogin/signin?prelogin_country_code=TW',
      logoutUrl: 'https://loginapi.plaync.com/login/logout',
      adminUrl: 'https://stage-preorder-admin.ncsoft.net',
    }    
  },
  live: {
    ncs:{
      staticAssetURL: 'https://assets.playnccdn.com',
      staticUrl: 'https://assets.playnccdn.com/uikit/preorder/client',
      loginUrl: 'https://login.plaync.com/nclogin/signin',
      logoutUrl: 'https://loginapi.plaync.com/login/logout',
      adminUrl: 'https://preorder-admin.ncsoft.net',
    },
    nct:{
      staticAssetURL: 'https://assets.playnccdn.com',
      staticUrl: 'https://assets.playnccdn.com/uikit/preorder/client',
      loginUrl: 'https://login.plaync.com/nclogin/signin?prelogin_country_code=TW',
      logoutUrl: 'https://loginapi.plaync.com/login/logout',
      adminUrl: 'https://preorder-admin.ncsoft.net',
    }    
  },
};

// 망 구분
const getNetworkType = (): Network => {
  const host = location.hostname;
  let network: Network = 'live';

  networkPattern.some((net) => {
    if (net.pattern) {
      if (net.pattern.test(host)) {
        network = net.name;
        return true;
      }
    } else {
      if (net.name === 'live') {
        network = net.name;
        return true;
      }
    }
    return false;
  });

  return network;
};

const getStaticPath = (zone:Zone = 'ncs'): string => {
  const protocol = location.protocol;
  const network = getNetworkType() as Network;
  const { staticUrl } = networkMap[network][zone];
  return `${protocol}//${staticUrl}`;
};

const getStaticNCUIPath = (zone:Zone = 'ncs'): string => {
  const protocol = location.protocol;
  const network = getNetworkType() as Network;
  const { staticAssetURL } = networkMap[network][zone];
  return `${staticAssetURL}/uikit/ncui`;
};

const getDefaultImagePath = () => {
  const network = getNetworkType() as Network;
  return network !== 'local'? `${getStaticPath()}/${version}/defaultImg` : `${getStaticPath()}/defaultImg`;
};

const getLoginUrl = (zone:Zone = 'ncs'): { loginUrl: string; logoutUrl: string } => {
  const network = getNetworkType() as Network;
  const { loginUrl, logoutUrl } = networkMap[network][zone];
  return { loginUrl, logoutUrl };
};


export { getStaticPath, getStaticNCUIPath, getLoginUrl, getDefaultImagePath };
